import { red } from '@mui/material/colors'
import { components } from './components'

const globalFont = 14;

const themeOptions = {
    typography: {
        fontSize: globalFont,
        body1: {
            fontSize: globalFont+'px',
        },
    },

    status: {
        danger: red[500],
    },
    components: {
        ...components,
    },
}

export {themeOptions , globalFont}
